import * as React from 'react';
import * as ReactModal from 'react-modal';
const classNames = require('classnames');

import { IconClose, IconHelpCircle } from '../../components/icons';
import Utils from '../../common/utils';

interface Props {
	title?: string;
	toggle?: {};
	toggleClassName?: string;
	className?: string;
	children?: {};
}

interface State {
	isOpen: boolean;
}

const ANIM_DURATION = 300;

class CustomTooltip extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isOpen: false
		};

		// http://reactcommunity.org/react-modal/accessibility/#app-element
		ReactModal.setAppElement('#root');
	}

	onRequestOpen = (e: React.MouseEvent<HTMLElement>) => {
		e.currentTarget.blur();
		Utils.disableBodyScrolling({allBreakpoints: true});
		this.setState({
			...this.state,
			isOpen: true
		});
	}

	onRequestClose = () => {
		Utils.enableBodyScrolling();
		this.setState({
			...this.state,
			isOpen: false
		});
	}

	render() {
		const props = this.props;
		return (
			<span className={props.className}>
				<button 
					type="button" 
					className={classNames(
						'btn btn-link btn-tooltip-modal-toggle', 
						props.toggleClassName, 
						{'btn-tooltip-modal-toggle-default': !props.toggle }
					)}
					onClick={this.onRequestOpen}
				>
					{props.toggle ? (
						props.toggle
					) : (
						<IconHelpCircle />
					)}
				</button>
				<ReactModal
					isOpen={this.state.isOpen}
					onRequestClose={this.onRequestClose}
					portalClassName="ReactModal" // Redefine className to remove inline styles
					overlayClassName="ReactModal_Overlay modal-overlay" // Redefine className to remove inline styles
					className="ReactModal_Content section section-main" // Redefine className to remove inline styles
					closeTimeoutMS={ANIM_DURATION}
				>
					{props.children}
					<button className="btn btn-icon ReactModal__Close" onClick={this.onRequestClose}>
						<IconClose />
					</button>
				</ReactModal>
			</span>
		);
	}
}

export default CustomTooltip;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/TooltipModal.tsx